<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="changePasDialogShow" top="30px" :before-close="hideDialog" width="600px"
    @open="openDialog">
    <div class="dialogblue">修改登录密码</div>
    <div class="dialogForm">
      <el-form :model="changepastemp" label-width="115px" label-position="right" :rules="rules" ref="changeForm">
        <el-form-item v-if="user.userType !== 0" label="旧密码:" prop="userOldPassword">
          <el-input type="password" autocomplete="new-password" v-model="changepastemp.userOldPassword" placeholder="请输入旧密码" />
        </el-form-item>
        <el-form-item label="新密码:" prop="userNewPassword">
          <el-input type="password" autocomplete="new-password" v-model="changepastemp.userNewPassword" placeholder="请输入密码" />
        </el-form-item>
        <el-form-item label="确认密码:" prop="userSurePassword">
          <el-input type="password" autocomplete="new-password" v-model="changepastemp.userSurePassword" placeholder="请输入确认密码" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="btntheme" size="mini" @click="handleUpdate">修改</el-button>
      <el-button size="mini" @click="hideDialog">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { changePassword } from '@/api/user'
// import { encrypt } from '@/utils/encrypt'·
export default {
  props: {
    changePasDialogShow: Boolean,
    user: Object
  },
  data () {
    return {
      changepastemp: {
      },
      rules: {
        userOldPassword: [{ required: true, trigger: 'change', message: '旧密码不能为空！' }],
        userNewPassword: [{ required: true, trigger: 'change', message: '新密码不能为空！' }],
        userSurePassword: [{ required: true, trigger: 'change', message: '确认密码不能为空！' }]
      }
    }
  },
  components: {
  },
  methods: {
    openDialog () {
      this.changepastemp = {
      }
    },
    handleUpdate () {
      this.$refs['changeForm'].validate(valid => {
        if (valid) {
          if (this.changepastemp.userNewPassword === this.changepastemp.userSurePassword) {
            const params = {
              userId: this.user.userId,
              userNewPassword: this.changepastemp.userNewPassword,
              userSurePassword: this.changepastemp.userSurePassword,
              userOldPassword: this.changepastemp.userOldPassword || false
            }
            const sendparams = JSON.parse(JSON.stringify(params))
            // sendparams.userNewPassword = encrypt(sendparams.userNewPassword)
            sendparams.userSurePassword = sendparams.userNewPassword
            // sendparams.userOldPassword = encrypt(sendparams.userOldPassword)
            changePassword(sendparams).then(res => {
              if (res.data.code === 10000) {
                this.$message({ showClose: true, type: 'success', message: '密码修改成功！' })
                this.hideDialog()
              }
            }).catch(() => {
            })
          } else {
            this.$message({ center: true, showClose: true, type: 'warning', message: '两次密码不一样' })
          }
        }
      })
    },
    hideDialog () {
      this.$emit('hideDialog')
    }
  },
  created () {
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 9px;
}
.dialogForm >>> .el-form-item__error {
  padding-top: 0px;
}
.dialogForm >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.dialogForm >>> .el-dialog__header {
  padding: 12px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/NavigationBar/changePas.vue